var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        [
          _c("Subheader", { attrs: { title: "Guideline Standards" } }),
          _vm._v(" "),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.currentStandards,
              "hide-actions": "",
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.AnalyteNameInGuideline)),
                    ]),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "text-xs-left",
                      domProps: {
                        innerHTML: _vm._s(_vm.getGuidelineValue(props.item)),
                      },
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.Unit)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { attrs: { width: "50%" } },
                      [
                        _vm._l(
                          props.item.linkedAnalytes,
                          function (link, index) {
                            return _c(
                              "v-chip",
                              {
                                key: `link-${index}`,
                                staticClass: "emphasize-close",
                                class: _vm.differentUnit(link, props.item)
                                  ? "amber lighten-4"
                                  : "",
                                attrs: { label: "", close: "" },
                                on: {
                                  input: function ($event) {
                                    return _vm.deleteStandard(link)
                                  },
                                },
                              },
                              [
                                _vm.differentUnit(link, props.item)
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c("v-icon", _vm._g({}, on), [
                                                    _vm._v("help_outline"),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "TenantGuidelinesDetailStandards.tooltipMsg"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-2" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "AnalyteDetailManage",
                                            params: {
                                              analyteId:
                                                link.analyteId.toString(),
                                            },
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(link.analyteName))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _vm._v(" "),
                        props.item.linkedAnalyte
                          ? _c(
                              "div",
                              {
                                staticClass: "align-center",
                                staticStyle: { display: "flex", width: "100%" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      props.item.linkedAnalyte.analyteName
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "min-width-none",
                            attrs: { depressed: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.addStandard(props.item)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { color: "success" } }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-none" }, [
                              _vm._v("Analyte"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800px" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("GuidelinesDetailStandards.addTitle")) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-form",
                  {
                    ref: "form",
                    staticStyle: { width: "100%" },
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        disabled: "",
                        required: "",
                        label: "Standard",
                        hint:
                          "Standard is used in unit group(s):" +
                          _vm.getHint(_vm.AnalyteStandardMap.Standard),
                        "persistent-hint": "",
                        items: _vm.originalData.Standards,
                        rules: [_vm.rules.required],
                        "item-text": "AnalyteNameInGuideline",
                        "return-object": "",
                      },
                      model: {
                        value: _vm.AnalyteStandardMap.Standard,
                        callback: function ($$v) {
                          _vm.$set(_vm.AnalyteStandardMap, "Standard", $$v)
                        },
                        expression: "AnalyteStandardMap.Standard",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-autocomplete", {
                      attrs: {
                        required: "",
                        label: "Linked Analyte",
                        items: _vm.availableAnalyteList,
                        "item-text": "AnalyteName",
                        "return-object": "",
                        rules: [_vm.rules.required],
                      },
                      model: {
                        value: _vm.AnalyteStandardMap.Analyte,
                        callback: function ($$v) {
                          _vm.$set(_vm.AnalyteStandardMap, "Analyte", $$v)
                        },
                        expression: "AnalyteStandardMap.Analyte",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { disabled: !_vm.valid, color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.checkData()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.addDialog,
          callback: function ($$v) {
            _vm.addDialog = $$v
          },
          expression: "addDialog",
        },
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.confirmDialog,
            callback: function ($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(_vm.$t("GuidelinesDetailStandards.deleteTitle"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("GuidelinesDetailStandards.confirmTitleMsg", {
                        analyteName: _vm.deleteAnalyteStandardMap.analyteName,
                      })
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "delete", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.deleteGuidelineStandard()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("link_off"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("Button.UnlinkAnalyte")) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }